import React from "react";
import { Link } from "react-router-dom";
import why from "../assets/img/why.png";
const WhyUs = () => {
    return (
        <><section className="section-space">
            <div className="container-xl">
                <div className="why-sec">
                    <div className="row">
                        <div className="col-lg-6">
                            <h2 className="m-heading">Why Choose<br />Endorse Learning? </h2>
                            <ul className="list-unstyled m-list">
                                <li>🔥 Comprehensive Learning Experience – Covering fundamentals to advanced topics for all skill levels.</li>
                                <li>📚 Wide Range of Courses – From tech and business to personal development and leadership.</li>
                                <li>⏳ Learn at Your Own Pace – Self-paced courses or structured schedules to fit your lifestyle.</li>
                                
                            </ul>
                            <a href="/contact" className="btn btn-white mr-top">Contact Us</a>
                        </div>
                        <div className="col-lg-6">
                        <img src={why} className='img-fluid why-girl' alt="" />
                        </div>
                    </div>
                </div>
            </div>
        </section>
        </>

    );
};

export default WhyUs;